export const ROAD_LINE_LENGTH_METERS = 15